// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"16a7631d","135":"c90b4a95","301":"6a49ff5e","453":"faf2f4f6","493":"650e375b","833":"0f0a76f8","937":"205a189b"}[chunkId] + ".chunk.js";
};